<template>
  <v-container
    data-vue-component-name="KeyboardButtonTest"
    fill-height
    fluid
    class="align-start pa-16"
    @click.self="logger($event, 'Whitespace', false)"
    @contextmenu.prevent.self="logger($event, 'Whitespace', false)"
  >
    <v-row class="flex-column events-none" align="center">
      <h3 class="font-weight-bold mb-2">{{ getExerciseTitle }}</h3>
      <progress-bar :value="progress" />
    </v-row>

    <v-row justify="center" class="space-x-15 events-none">
      <v-btn
        v-for="(word, index) in ['Z', 'M']"
        :key="index"
        :depressed="!isActiveIndex(index)"
        :color="isActiveIndex(index) ? 'primary' : 'secondary'"
        class="text-capitalize events-auto"
        width="175"
        style="transition: 0.5s"
        @click="logger(
          $event,
          isActiveIndex(index) ? 'ActiveButton' : 'InactiveButton',
          false,
        )"
        @contextmenu="logger(
          $event,
          isActiveIndex(index) ? 'ActiveButton' : 'InactiveButton',
          false,
        )"
      >
        Button {{ index + 1 }} ({{ word }})
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { softGet } from '@/composables';
import ProgressBar from '@/components/ProgressBar.vue';

const EVENT_TYPES = {
  click: 'leftClickDown',
  contextmenu: 'rightClickDown',
  keydown: 'keyButtonDown',
};

export default {
  name: 'KeyboardButtonTest',
  components: { ProgressBar },
  data() {
    return {
      activeIndex: null,
      progress: 0,
      logs: [],
    };
  },
  mounted() {
    this.updateActiveIndex();
    document.addEventListener('keydown', this.onKeyDown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeyDown);
  },
  computed: {
    ...mapGetters([
      'getExerciseTitle',
      'getNumberOfSuccessAttempts',
    ]),
    validKeys: () => ['KeyZ', 'KeyM'],
  },
  methods: {
    isActiveIndex(index) {
      return index === this.activeIndex;
    },
    correctClickHandler() {
      this.incrementProgress();
      this.updateActiveIndex();

      if (this.progress === 100) {
        this.activeIndex = null;

        this.$store.commit('SAVE_LOG', {
          key: 'keyboard_buttons_test',
          payload: this.logs,
        });

        this.$emit('next');
      }
    },
    updateActiveIndex() {
      this.activeIndex = Number(!this.activeIndex);
    },
    incrementProgress() {
      this.progress += (100 / this.getNumberOfSuccessAttempts);
    },
    logger(e, hit_target, correct) {
      this.logs.push({
        event_type: EVENT_TYPES[e.type],
        timestamp: Date.now(),
        x_coord: softGet(e, 'x', null),
        y_coord: softGet(e, 'y', null),
        viewport_width: window.innerWidth,
        viewport_height: window.innerHeight,
        hit_target,
        correct,
        key_value: e.code || null,
      });

      if (correct) this.correctClickHandler();
    },
    onKeyDown(e) {
      this.logger(
        e,
        null,
        this.validKeys.includes(e.code)
        && this.validKeys[this.activeIndex] === e.code,
      );
    },
  },
};
</script>
